<template>
    <ul class="list-group list-group-flush list-group-hover">
        <template v-for="media of items" :key="media.id">
            <div class="list-group-item list-video-element d-flex ">
                <CheckMedia :selecting="selecting" :media="media"></CheckMedia>

                <div class="d-flex list-group-item-action cursor-pointer" data-bs-toggle="modal" :data-bs-target="'#videoPlayerModal' + media.id">
                    <img :src="redArrow" class="red-arrow" :alt="media.name">
                    <span class="ms-4">{{ media.name }}</span>

                    <div class="ms-auto user-select-none">
                        <Check v-if="media.is_downloaded"></Check>

                        <VideoMetaData class="ms-3" :media="media"></VideoMetaData>
                    </div>
                </div>
            </div>

            <VideoModal :media="media"></VideoModal>
        </template>
    </ul>
</template>

<script setup lang="ts">
import {MediaItem} from "@/site/components/VideoElement.vue";
import VideoMetaData from "@/site/components/VideoMetaData.vue";
import VideoModal from "@/site/components/VideoModal.vue";
import CheckMedia from "@/site/components/CheckMedia.vue";
import Check from "@/site/components/Icons/Check.vue";

const redArrow = window.global.red_arrow;

defineProps<{
    items: MediaItem[],
    selecting: boolean,
}>();
</script>

<style scoped>

</style>
